import { useMetricData } from '../useMetricSeries';
import { useDodData } from '../useDodSeries';
import { pick } from 'lodash';
import useExportMetrics from './useExportMetrics';
import { DATA_TAGS } from '../useData';
import { useAtomValue } from 'jotai';
import { percentileAtom } from '../../atoms';
import useSetChartExportWithPercentile from './useSetChartExportWithPercentile';
import { getPercentileMetrics } from '@src/utils/metrics/metricHelpers';

function useSetTimeSeriesExport() {
  const exportMetrics = useExportMetrics();
  const percentile = useAtomValue(percentileAtom);

  // metric series
  const { data: metricRows = {}, totals: metricTotals = {} } = useMetricData({
    dataTag: DATA_TAGS.primary,
  });

  // secondary metric series
  const { data: secondaryMetricRows = {}, totals: secondaryMetricTotals = {} } = useMetricData({
    dataTag: DATA_TAGS.secondary,
  });
  const percentileMetricsList = getPercentileMetrics();
  useSetChartExportWithPercentile({
    pageKey: 'trends',
    sectionKey: 'metrics-panel',
    widgetKey: 'primary-timeseries',
    widgetInfo: { title: 'Timeseries' },
    data: pick({ ...metricRows, ...secondaryMetricRows }, exportMetrics),
    totals: pick({ ...metricTotals, ...secondaryMetricTotals }, exportMetrics),
    percentile,
    percentileMetricsList,
  });

  // dod series
  const { data: dodRows = {}, totals: metricDodTotals = {} } = useDodData({
    dataTag: DATA_TAGS.primaryDod,
  });

  // secondary dod series
  const { data: secondaryDodRows = {}, totals: secondaryDodTotals = {} } = useDodData({
    dataTag: DATA_TAGS.secondaryDod,
  });

  useSetChartExportWithPercentile({
    pageKey: 'trends',
    sectionKey: 'metrics-panel',
    widgetKey: `dod-timeseries`,
    widgetInfo: {
      title: 'Date Comparison: Timeseries',
    },
    data: pick({ ...dodRows, ...secondaryDodRows }, exportMetrics),
    totals: pick({ ...metricDodTotals, ...secondaryDodTotals }, exportMetrics),
    percentile,
    percentileMetricsList,
  });
}

export default useSetTimeSeriesExport;
